import { getAbelSDK } from "@/lib/abel";
import { queryClient } from "@/lib/query-client";
import { useQuery } from "@tanstack/react-query";
import { AssetTinyLabels } from "abel-sdk";

export const useAbelAssets = (abelAppId: bigint, assetIds?: bigint[]) => {
  const queryKeyIDs = (assetIds ?? [])
    .map((n) => Number(n))
    .sort((a, b) => (a < b ? -1 : 1))
    .join("-");
  return useQuery({
    queryKey: ["abel-assets", queryKeyIDs],
    // staleTime: 60 * 60 * 1_000, // 1 hr
    staleTime: 1000,
    queryFn: async (): Promise<null | Map<bigint, AssetTinyLabels>> => {
      console.log("Getting abel", abelAppId, "assets", assetIds)
      if (!abelAppId) return null;
      const abelSDK = getAbelSDK(abelAppId);
      if (!assetIds) {
        assetIds = await abelSDK.getAllAssetIDs()
      }
      // const cached = ...  
      // TODO zustand cache check, filter out asset IDs
      try {
        const results = await abelSDK.getAssetsTinyLabels(assetIds);
        return results
      } catch(e) {
        console.error(e)
        throw e
      }
      // TODO zustand cache set
      // TODO results merge from cached and new
      
    },
  });
};

export const clearAbelCache = () => {
  queryClient.invalidateQueries({ queryKey: ["abel-assets"] });
};
